<div class="btn-group" role="group">
  <button type="button" class="btn" (click)="setAnswer(true)" [class.btn-light]="result!==true" [class.btn-success]="result===true">Yes</button>
  <button type="button" class="btn" (click)="setAnswer(false)" [class.btn-light]="result!==false" [class.btn-success]="result===false">No</button>
</div>
